import { Injectable } from '@angular/core';
import { ForecastProvidersEnum } from '../data-services/graphql';
import { ThemeService } from '@wind-log_library/fe-component-library';

@Injectable({
  providedIn: 'root'
})
export class ProvidersColorsService {

  private providersColors = {
    windlog: () => this.themeService.getColor('--primary-background'),
    meteoblue: () => this.themeService.getColor('--yellow'),
    openweather: () => this.themeService.getColor('--green'),
    nems: () => 'rgb(160,98,21)',
    ecmwf: () => this.themeService.getColor('--secondary')
  };
  constructor(private themeService: ThemeService) { }

  public getForecastProviderBorderColor(provider: ForecastProvidersEnum): string {
    return this.providersColors[provider] ?  this.providersColors[provider]() : this.themeService.getColor('--primary-background');
  }
}
